import { gql } from 'graphql-request';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useAdminDeleteManualPayment = () => {
  const { client } = graphqlConfig();

  const Mutation = useMutation(async ({ paymentId }: { paymentId: number }) => client.request(
    gql`
    mutation AdminDeleteManualPayment($paymentId: Float!) {
      adminDeleteManualPayment(paymentId: $paymentId) {
        message
      }
    }
    `,
    {
      paymentId
    }
  ));
  return Mutation;
};
